/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonCompanyPositionInfo
 */
export interface JsonCompanyPositionInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonCompanyPositionInfo
     */
    allowedActions?: Array<JsonCompanyPositionInfoAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyPositionInfo
     */
    companyId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyPositionInfo
     */
    companyPositionId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyPositionInfo
     */
    positionId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonCompanyPositionInfo
     */
    status?: JsonCompanyPositionInfoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonCompanyPositionInfo
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyPositionInfo
     */
    userCount?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonCompanyPositionInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonCompanyPositionInfoStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonCompanyPositionInfoFromJSON(json: any): JsonCompanyPositionInfo {
    return JsonCompanyPositionInfoFromJSONTyped(json, false);
}

export function JsonCompanyPositionInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonCompanyPositionInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyPositionId': !exists(json, 'companyPositionId') ? undefined : json['companyPositionId'],
        'positionId': !exists(json, 'positionId') ? undefined : json['positionId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'userCount': !exists(json, 'userCount') ? undefined : json['userCount'],
    };
}

export function JsonCompanyPositionInfoToJSON(value?: JsonCompanyPositionInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'companyId': value.companyId,
        'companyPositionId': value.companyPositionId,
        'positionId': value.positionId,
        'status': value.status,
        'title': value.title,
        'userCount': value.userCount,
    };
}

